<app-header></app-header>
<!-- Start of Desktop Content -->
<ion-content
  *ngIf="(platformService?.isTouchExperience$ | async) === false"
  class="gray-content-bg"
  scroll-y="false"
>
  <ion-grid [class.hide]="isSelectedListLoaded$ | async" [fixed]="true">
    <app-list-skeleton></app-list-skeleton>
  </ion-grid>
  <div [class.hide]="(isSelectedListLoaded$ | async) === false" id="desktop">
    <cdk-virtual-scroll-viewport
      id="list-scroll-Recently Purchased"
      data-cy="recently-purchased-desktop-scroll"
      class="cdk-scroll"
      orientation="vertical"
      appCustomVs
      [itemHeights]="vm?.itemHeights"
      [indexOffset]="2"
      [items]="vm?.items"
      [listId]="listTypes.recentlyPurchased"
    >
      <ion-grid class="grid-padding" [fixed]="true">
        <!-- Breadcrumbs -->
        <ion-row class="breadcrumbs-section">
          <ion-col size="8">
            <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
          </ion-col>
          <ion-col size="4">
            <ion-row class="interact-download">
              <ion-label (click)="openDownloadPrintModal(false)">
                <ion-icon name="print-outline"></ion-icon>
                {{ 'i18n.common.print' | translate }}
              </ion-label>
              <ion-label (click)="openDownloadPrintModal(true)">
                <ion-icon name="download-outline"></ion-icon>
                {{ 'i18n.common.download' | translate }}
              </ion-label>
            </ion-row>
          </ion-col>
        </ion-row>

        <!-- List Banner -->
        <app-list-banner
          [listName]="listName"
          [listItemCount]="vm?.totalItemCount"
          [showEllipsis]="(vm?.showEllipsis || copyListEnabled) && !vm?.pmeListFeatureFlag"
          (ellipsisClickEventEmitter)="openListOptions($event)"
        ></app-list-banner>

        <ion-row class="ion-margin-top">
          <ion-col size-xl="2.4" size-lg="3.05" size-md="3.35">
            <ng-container [ngTemplateOutlet]="searchBar"></ng-container>
          </ion-col>
          <ion-col offset="0.15" size-xl="6.4" size-lg="4.75" size-md="4.5">
            <ng-container
              *ngIf="vm?.selectedListViewModel?.selectedListViewMode !== ListViewMode.pricing"
              [ngTemplateOutlet]="addToListButton"
            ></ng-container>
          </ion-col>
          <ion-col
            *ngIf="vm?.pmeListFeatureFlag"
            offset-xl="0.25"
            offset-lg="0.5"
            offset-md="0.15"
            size-xl="2.15"
            size-lg="2.75"
            size-md="3.1"
          >
            <ng-container
              [ngTemplateOutlet]="pmeToggle"
              [ngTemplateOutletContext]="{ listViewMode: vm?.selectedListViewModel?.selectedListViewMode }"
            ></ng-container>
          </ion-col>
          <ion-col
            *ngIf="vm?.pmeListFeatureFlag"
            offset="0.35"
            size-xl="0.25"
            size-lg="0.4"
            size-md="0.4"
          >
            <ng-container [ngTemplateOutlet]="newEllipsis"></ng-container>
          </ion-col>
        </ion-row>
        <ion-row class="ion-margin-top">
          <ion-col size-xl="9" size-lg="8" size-md="8" size-sm="9" size-xs="9">
            <div class="sort-filter-buttons-container">
              <ng-container
                [ngTemplateOutlet]="sortAndFilterButton"
              ></ng-container>
              <app-pme-list-filter-buttons
                *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
                [platformType]="platformService?.platformType"
                [filters]="vm?.pmeSortFilterOptions?.filters || []"
                (filtersChange)="handleFiltersChange($event)"
              ></app-pme-list-filter-buttons>
            </div>
          </ion-col>
          <!-- PME Friday Toggle Desktop -->
          <ion-col
            *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing && isFriday$ | async"
            class="pme-toggle-column-desktop"
          >
            <app-usf-pme-toggle
              [fridayDate]="fridayDate"
              [saturdayDate]="saturdayDate"
              [toggleIsOn]="vm?.selectedListViewModel?.fridayToggleOn"
              [toggleIsDisabled]="clientListViewService.isAnyEasyPricingProcessingForSelectedList$ | async"
              (toggleChange)="handleFridayToggleChange($event)"
            ></app-usf-pme-toggle>
          </ion-col>
        </ion-row>
        <ion-row class="main-content">
          <!-- No Results -->
          <ion-col
            [class.hide]="vm?.items?.length !== 0"
            size-xl="9"
            size-lg="8"
            size-md="8"
            size-sm="9"
            size-xs="9"
          >
            <app-no-products-in-group
              [listCount]="vm?.totalItemCount"
              [itemsLeftAfterFilter]="vm?.items?.length"
              [isEditableList]="false"
              [isMobile]="false"
              [isListManagement]="false"
            ></app-no-products-in-group>
          </ion-col>
          <!-- List of groups and products -->
          <ion-col
            [class.hide]="vm?.items?.length === 0"
            size-xl="9"
            size-lg="8"
            size-md="8"
            size-sm="9"
            size-xs="9"
          >
            <app-group-product-list-desktop
              [items]="vm?.items"
              [mode]="mode"
              [pricingDisabled]="vm?.selectedCustomer?.ogPrintPriceInd === 'N'"
              [isOnline]="(panAppState.online$ | async)"
              [showNotes]="false"
              [selectable]="vm?.isSelected"
              [listViewMode]="vm?.selectedListViewModel?.selectedListViewMode"
              [hideLowLimit]="vm?.pmeLowLimitFeatureFlag"
              [selectedListType]="vm?.selectedListViewModel?.selectedListType"
              [screenWidth]="vm?.platform?.width"
              [platformType]="vm?.platform?.platformType"
              [selectedListItemKey]="vm?.selectedListViewModel?.selectedListItemKey"
              (ellipsisEmitter)="openProductCardEllipsis($event)"
              (infoIconClickEmitter)="openProductStatus($event)"
              (productCardClickEmitter)="routeToPDP($event)"
              (promotionClickEmitter)="clickPromotions($event)"
              (quantityInputEmitter)="quantityFocusHandler($event)"
              (quantityUpdateEmitter)="changeQuantityHandler($event)"
              (betterBuyDeclineEmitter)="handleBetterBuyDeclineClick($event)"
              (acceptSwapEmitter)="acceptSwap($event)"
              (selectProductCardEmitter)="selectAProduct($event)"
              (productConversionEmitter)="productConversionEmitter($event)"
              (priceChanged)="emitPriceChanged($event)"
              (PMEProductCardClickEmitter)="handlePmeProductClick($event)"
              (closeManualApproval)="handleCloseManualApproval($event)"
            >
            </app-group-product-list-desktop>
          </ion-col>
          <ion-col
            offset-xl="0.25"
            offset-lg="0.5"
            offset-md="0.1"
            size-xl="2.75"
            size-lg="3.5"
            size-md="3.9"
          >
            <app-order-info-sidebar
              *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.ordering"
              [platform]="platformService?.platformType"
              [orderHeader]="vm?.orderHeader"
              [orderItemTallies]="vm?.orderItemTallies"
              [isList]="true"
              [isCart]="false"
              [isOnMinimumOrderMetFlag]="vm?.orderMinimumMetFeatureFlag"
              [showPrintIcon]="false"
            >
            </app-order-info-sidebar>
          </ion-col>
        </ion-row>
      </ion-grid>
      <!-- Footer -->
      <div id="footer">
        <app-footer></app-footer>
      </div>
    </cdk-virtual-scroll-viewport>
    <!-- Price Mode Sidebar -->
    <div
      #priceModeSidebar
      class="desktop-sidebar"
      *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
    >
      <ion-grid
        [class.hide]="(isSelectedListLoaded$ | async) === false"
        [fixed]="true"
      >
        <ion-row>
          <ion-col
            size-xl="9"
            size-lg="8"
            size-md="8"
            size-sm="9"
            size-xs="9"
          ></ion-col>
          <ion-col
            offset-xl="0.25"
            offset-lg="0.5"
            offset-md="0.1"
            size-xl="2.75"
            size-lg="3.5"
            size-md="3.9"
          >
            <app-pme-right-rail
              *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
              [isMobile]="false"
              [product]="vm?.selectedProduct"
              [hideLowLimit]="vm?.pmeLowLimitFeatureFlag"
              [showSGP]="vm?.pmeSGPFeatureFlag"
              (productDetailsClick)="routeToPDP({productNumber: vm?.selectedProduct?.productNumber, isQuickView: false})"
            >
            </app-pme-right-rail>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
  <!-- Selected Products Footer -->
  <ng-container [ngTemplateOutlet]="selectedProductsFooter"></ng-container>
</ion-content>

<!-- Start of Tablet Content -->
<ion-content
  *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
  class="gray-content-bg"
  scroll-y="false"
>
  <ion-grid [class.hide]="isSelectedListLoaded$ | async" [fixed]="true">
    <app-list-skeleton></app-list-skeleton>
  </ion-grid>
  <cdk-virtual-scroll-viewport
    id="list-scroll-Recently Purchased"
    [class.hide]="(isSelectedListLoaded$ | async) === false"
    data-cy="recently-purchased-tablet-scroll"
    class="cdk-scroll"
    orientation="vertical"
    appCustomVs
    [itemHeights]="vm?.itemHeights"
    [indexOffset]="2"
    [items]="vm?.items"
    [listId]="listTypes.recentlyPurchased"
  >
    <!-- List Banner -->
    <app-list-banner
      [listName]="listName"
      [listItemCount]="vm?.totalItemCount"
      [showEllipsis]="(vm?.showEllipsis || copyListEnabled) && !vm?.pmeListFeatureFlag"
      (ellipsisClickEventEmitter)="openListOptions($event)"
      (downloadClickEventEmitter)="openDownloadPrintModal(true)"
      (printClickEventEmitter)="openDownloadPrintModal(false)"
    ></app-list-banner>

    <ion-grid class="grid-padding" [fixed]="true">
      <!-- Pricing mode layout -->
      <ion-row
        class="ion-margin-top"
        *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
      >
        <ion-col
          size-xl="8"
          size-lg="8"
          size-md="7.5"
          size-sm="7.5"
          class="search-sort-container-tablet"
        >
          <ng-container [ngTemplateOutlet]="searchBar"></ng-container>
          <ng-container [ngTemplateOutlet]="sortAndFilterButton"></ng-container>
        </ion-col>
        <ion-col
          *ngIf="vm?.pmeListFeatureFlag"
          offset="0.25"
          size-lg="3"
          size-md="3.25"
          size-sm="3.25"
        >
          <ng-container
            [ngTemplateOutlet]="pmeToggle"
            [ngTemplateOutletContext]="{ listViewMode: vm?.selectedListViewModel?.selectedListViewMode }"
          ></ng-container>
        </ion-col>
        <ion-col
          *ngIf="vm?.pmeListFeatureFlag"
          offset-lg="0.25"
          size-lg="0.5"
          offset-md="0.5"
          size-md="0.5"
          offset-sm="0.5"
          size-sm="0.5"
        >
          <ng-container [ngTemplateOutlet]="newEllipsis"></ng-container>
        </ion-col>
      </ion-row>

      <!-- Non-pricing mode layout -->
      <ion-row
        class="ion-margin-top"
        *ngIf="vm?.selectedListViewModel?.selectedListViewMode !== ListViewMode.pricing"
      >
        <ion-col size-xl="8" size-lg="8" size-md="7.5" size-sm="7.5">
          <ng-container [ngTemplateOutlet]="searchBar"></ng-container>
        </ion-col>
        <ion-col
          *ngIf="vm?.pmeListFeatureFlag"
          offset="0.25"
          size-lg="3"
          size-md="3.25"
          size-sm="3.25"
        >
          <ng-container
            [ngTemplateOutlet]="pmeToggle"
            [ngTemplateOutletContext]="{ listViewMode: vm?.selectedListViewModel?.selectedListViewMode }"
          ></ng-container>
        </ion-col>
        <ion-col
          *ngIf="vm?.pmeListFeatureFlag"
          offset-lg="0.25"
          size-lg="0.5"
          offset-md="0.5"
          size-md="0.5"
          offset-sm="0.5"
          size-sm="0.5"
        >
          <ng-container [ngTemplateOutlet]="newEllipsis"></ng-container>
        </ion-col>
      </ion-row>

      <ion-row
        class="ion-margin-top"
        *ngIf="vm?.selectedListViewModel?.selectedListViewMode !== ListViewMode.pricing"
      >
        <ion-col
          size-xl="8"
          size-lg="8"
          size-md="7.5"
          size-sm="7.5"
          style="display: flex; justify-content: space-between"
        >
          <ng-container [ngTemplateOutlet]="addToListButton"></ng-container>
          <ng-container [ngTemplateOutlet]="sortAndFilterButton"></ng-container>
        </ion-col>
      </ion-row>

      <!-- PME toggle for pricing mode -->
      <!-- PME Friday Toggle Tablet -->
      <ion-row
        *ngIf="vm?.pmeListFeatureFlag && vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
        class="ion-margin-top"
      >
        <!-- tablet -->
        <ion-col
          size-xl="8"
          size-lg="8"
          size-md="7.5"
          size-sm="7.5"
          class="pme-filter-buttons-col"
        >
          <div
            class="sort-filter-buttons-container tablet-filter-buttons-scroll"
          >
            <div class="scroll-content">
              <app-usf-pme-toggle
                [class.hide]="(isFriday$ | async) === false"
                [fridayDate]="fridayDate"
                [saturdayDate]="saturdayDate"
                [toggleIsOn]="vm?.selectedListViewModel?.fridayToggleOn"
                [toggleIsDisabled]="clientListViewService.isAnyEasyPricingProcessingForSelectedList$ | async"
                (toggleChange)="handleFridayToggleChange($event)"
              ></app-usf-pme-toggle>
              <app-pme-list-filter-buttons
                [platformType]="platformService?.platformType"
                [filters]="vm?.pmeSortFilterOptions?.filters || []"
                (filtersChange)="handleFiltersChange($event)"
              ></app-pme-list-filter-buttons>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <!-- Main Content-->
      <ion-row>
        <!-- No Results -->
        <ion-col
          [class.hide]="vm?.items?.length !== 0"
          size-xl="8"
          size-lg="8"
          size-md="7.5"
          size-sm="7"
        >
          <app-no-products-in-group
            [listCount]="vm?.totalItemCount"
            [itemsLeftAfterFilter]="vm?.items?.length"
            [isEditableList]="false"
            [isMobile]="false"
            [isListManagement]="false"
          ></app-no-products-in-group>
        </ion-col>
        <!-- List of groups and products -->
        <ion-col
          [class.hide]="vm?.items?.length === 0"
          size-xl="8"
          size-lg="8"
          size-md="7.5"
          size-sm="7.5"
        >
          <app-group-product-list-touch
            [items]="vm?.items"
            [mode]="mode"
            [pricingDisabled]="vm?.selectedCustomer?.ogPrintPriceInd === 'N'"
            [isOnline]="(panAppState.online$ | async)"
            [isMobile]="false"
            [showNotes]="false"
            [selectable]="vm?.isSelected"
            [listViewMode]="vm?.selectedListViewModel?.selectedListViewMode"
            [hideLowLimit]="vm?.pmeLowLimitFeatureFlag"
            [selectedListType]="vm?.selectedListViewModel?.selectedListType"
            [screenWidth]="vm?.platform?.width"
            [platformType]="vm?.platform?.platformType"
            [selectedListItemKey]="vm?.selectedListViewModel?.selectedListItemKey"
            (ellipsisEmitter)="openProductCardEllipsis($event)"
            (infoIconClickEmitter)="openProductStatus($event)"
            (productCardClickEmitter)="routeToPDP($event)"
            (promotionClickEmitter)="clickPromotions($event)"
            (quantityInputEmitter)="quantityFocusHandler($event)"
            (quantityUpdateEmitter)="changeQuantityHandler($event)"
            (betterBuyDeclineEmitter)="handleBetterBuyDeclineClick($event)"
            (acceptSwapEmitter)="acceptSwap($event)"
            (selectProductCardEmitter)="selectAProduct($event)"
            (productConversionEmitter)="productConversionEmitter($event)"
            (priceChanged)="emitPriceChanged($event)"
            (PMEProductCardClickEmitter)="handlePmeProductClick($event)"
            (closeManualApproval)="handleCloseManualApproval($event)"
          >
          </app-group-product-list-touch>
        </ion-col>
        <ion-col
          size-xl="3.7"
          size-lg="3.7"
          size-md="4.2"
          push-md="0.3"
          push-sm="0.3"
          size-sm="4.2"
        >
          <app-order-info-sidebar
            *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.ordering"
            [platform]="platformService?.platformType"
            [orderHeader]="vm?.orderHeader"
            [orderItemTallies]="vm?.orderItemTallies"
            [isList]="true"
            [isCart]="false"
            [isOnMinimumOrderMetFlag]="vm?.orderMinimumMetFeatureFlag"
            [showPrintIcon]="false"
          ></app-order-info-sidebar>
        </ion-col>
      </ion-row>
    </ion-grid>
  </cdk-virtual-scroll-viewport>
  <!-- Price Mode Sidebar Tablet -->
  <div
    #priceModeSidebar
    [class]="'tablet-sidebar' + ((platformService?.platformType === platformService?.platformEnum?.tablet && vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing) ? ' tablet-sidebar-pricing' : '')"
    *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
  >
    <ion-grid
      [class.hide]="(isSelectedListLoaded$ | async) === false"
      [fixed]="true"
    >
      <ion-row>
        <ion-col size-xl="8" size-lg="8" size-md="7.5" size-sm="7.5"></ion-col>
        <ion-col
          size-xl="3.7"
          size-lg="3.7"
          size-md="4.2"
          push-md="0.3"
          push-sm="0.3"
          size-sm="4.2"
        >
          <app-pme-right-rail
            *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
            [isMobile]="false"
            [product]="vm?.selectedProduct"
            [hideLowLimit]="vm?.pmeLowLimitFeatureFlag"
            [showSGP]="vm?.pmeSGPFeatureFlag"
            (productDetailsClick)="routeToPDP({productNumber: vm?.selectedProduct?.productNumber, isQuickView: false})"
          ></app-pme-right-rail>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <!-- Selected Products Footer -->
  <ng-container [ngTemplateOutlet]="selectedProductsFooter"></ng-container>
</ion-content>

<!-- Start of Mobile Content -->
<ion-content
  *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
  class="gray-content-bg"
  scroll-y="false"
>
  <cdk-virtual-scroll-viewport
    id="mobile-scroll"
    data-cy="recently-purchased-mobile-scroll"
    class="cdk-scroll"
    orientation="vertical"
    appCustomVs
    [itemHeights]="vm?.itemHeights"
    [indexOffset]="2"
    [items]="vm?.items"
    [listId]="listTypes.recentlyPurchased"
  >
    <app-list-skeleton
      [class.hide]="isSelectedListLoaded$ | async"
    ></app-list-skeleton>

    <ion-grid
      [fixed]="true"
      [class.hide]="(isSelectedListLoaded$ | async) === false"
    >
      <ion-row class="ion-margin-top" *ngIf="vm?.pmeListFeatureFlag">
        <ion-col>
          <ng-container
            [ngTemplateOutlet]="pmeToggle"
            [ngTemplateOutletContext]="{ listViewMode: vm?.selectedListViewModel?.selectedListViewMode }"
          ></ng-container>
        </ion-col>
      </ion-row>
      <!-- List Banner -->
      <app-list-banner
        [listName]="listName"
        [listItemCount]="vm?.totalItemCount"
        [showEllipsis]="(vm?.showEllipsis || copyListEnabled)"
        (ellipsisClickEventEmitter)="openListOptions($event)"
      ></app-list-banner>
      <!-- Search, Sort & Filter -->
      <!-- Non-pricing mode -->
      <ion-row
        class="ion-margin-top"
        *ngIf="vm?.selectedListViewModel?.selectedListViewMode !== ListViewMode.pricing"
      >
        <ion-col size="12">
          <ng-container [ngTemplateOutlet]="searchBar"></ng-container>
        </ion-col>
      </ion-row>
      <ion-row
        class="ion-margin-top"
        *ngIf="vm?.selectedListViewModel?.selectedListViewMode !== ListViewMode.pricing"
      >
        <ion-col size="5.85">
          <ng-container [ngTemplateOutlet]="addToListButton"></ng-container>
        </ion-col>
        <ion-col offset="0.3" size="5.85">
          <ng-container [ngTemplateOutlet]="sortAndFilterButton"></ng-container>
        </ion-col>
      </ion-row>

      <!-- Pricing mode -->
      <ion-row
        class="ion-margin-top"
        *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
      >
        <ion-col size="12">
          <div class="mobile-search-filter-container">
            <div class="search-section search-sort-container-mobile">
              <ng-container [ngTemplateOutlet]="searchBar"></ng-container>
              <ng-container
                [ngTemplateOutlet]="sortAndFilterButton"
              ></ng-container>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-row
        *ngIf="vm?.pmeListFeatureFlag && vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
        class="ion-margin-top"
      >
        <ion-col size="12">
          <div
            class="sort-filter-buttons-container mobile-pme-list-filter-buttons-scroll"
          >
            <app-usf-pme-toggle
              [class.hide]="(isFriday$ | async) !== true"
              [fridayDate]="fridayDate"
              [saturdayDate]="saturdayDate"
              [toggleIsOn]="vm?.selectedListViewModel?.fridayToggleOn"
              [toggleIsDisabled]="clientListViewService.isAnyEasyPricingProcessingForSelectedList$ | async"
              (toggleChange)="handleFridayToggleChange($event)"
            ></app-usf-pme-toggle>
            <app-pme-list-filter-buttons
              [platformType]="platformService?.platformType"
              [filters]="vm?.pmeSortFilterOptions?.filters || []"
              (filtersChange)="handleFiltersChange($event)"
            ></app-pme-list-filter-buttons>
          </div>
        </ion-col>
      </ion-row>

      <!-- List of groups and products -->
      <app-group-product-list-touch
        [items]="vm?.items"
        [mode]="mode"
        [pricingDisabled]="vm?.selectedCustomer?.ogPrintPriceInd === 'N'"
        [isOnline]="(panAppState.online$ | async)"
        [isMobile]="true"
        [showNotes]="false"
        [selectable]="vm?.isSelected"
        [listViewMode]="vm?.selectedListViewModel?.selectedListViewMode"
        [hideLowLimit]="vm?.pmeLowLimitFeatureFlag"
        [selectedListType]="vm?.selectedListViewModel?.selectedListType"
        [screenWidth]="vm?.platform?.width"
        [platformType]="vm?.platform?.platformType"
        [selectedListItemKey]="vm?.selectedListViewModel?.selectedListItemKey"
        (ellipsisEmitter)="openProductCardEllipsis($event)"
        (infoIconClickEmitter)="openProductStatus($event)"
        (productCardClickEmitter)="routeToPDP($event)"
        (promotionClickEmitter)="clickPromotions($event)"
        (quantityInputEmitter)="quantityFocusHandler($event)"
        (quantityUpdateEmitter)="changeQuantityHandler($event)"
        (betterBuyDeclineEmitter)="handleBetterBuyDeclineClick($event)"
        (acceptSwapEmitter)="acceptSwap($event)"
        (selectProductCardEmitter)="selectAProduct($event)"
        (productConversionEmitter)="productConversionEmitter($event)"
        (priceChanged)="emitPriceChanged($event)"
        (PMEProductCardClickEmitter)="handlePmeProductClick($event)"
        (closeManualApproval)="handleCloseManualApproval($event)"
      >
      </app-group-product-list-touch>
      <!-- No Results -->
      <ion-row *ngIf="vm?.items?.length === 0">
        <ion-col size="12">
          <app-no-products-in-group
            [listCount]="vm?.totalItemCount"
            [itemsLeftAfterFilter]="vm?.items?.length"
            [isEditableList]="false"
            [isMobile]="false"
            [isListManagement]="false"
          ></app-no-products-in-group>
        </ion-col>
      </ion-row>
    </ion-grid>
  </cdk-virtual-scroll-viewport>
  <!-- Selected Products Footer -->
  <ng-container [ngTemplateOutlet]="selectedProductsFooter"></ng-container>
</ion-content>

<div
  [class.static-buttons]="platformService.platformType === platformService.platformEnum.mobile && showTopButton"
  data-cy="recently-purchased-static-buttons-section"
>
  <div
    *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile && vm?.orderItemTallies?.totalItems > 0"
    data-cy="recently-purchased-review-order-button-section"
    class="review-order-mobile"
  >
    <ion-button
      data-cy="recently-purchased-review-order-button"
      class="usf-fill-green-mobile-modal-button"
      (click)="routeTo('/order')"
    >
      {{ 'i18n.lists.reviewOrder' | translate }}
    </ion-button>
  </div>
  <div
    *ngIf="showTopButton"
    data-cy="recently-purchased-top-button-section"
    class="top-button"
  >
    <ion-button
      data-cy="recently-purchased-top-button"
      class="usf-fill-green-button"
      (click)="goToTop()"
    >
      {{ 'i18n.common.top' | translate }}&nbsp;
      <ion-icon
        data-cy="recently-purchased-top-button-icon"
        name="chevron-up-circle-outline"
      ></ion-icon>
    </ion-button>
  </div>
</div>

<!-- SEARCH, SORT & FILTER TEMPLATE -->
<ng-template #searchBar>
  <div
    data-cy="recently-purchased-search-sort-filter-section"
    class="search-sort-filter-section"
  >
    <div class="search-container">
      <ion-searchbar
        id="list-search-bar-Recently Purchased-0"
        data-cy="recently-purchased-searchbar"
        class="search"
        globalkeyhandler="filterBar"
        mode="md"
        placeholder="{{ 'i18n.lists.searchWithinYourList' | translate }}"
        [(ngModel)]="searchKey"
        (ionInput)="search()"
        (ionClear)="resetSearch()"
        (search)="search()"
        (ionFocus)="selectFirstProductForPricing()"
      >
      </ion-searchbar>
    </div>
  </div>
</ng-template>

<ng-template #sortAndFilterButton>
  <app-sort-and-filter-button
    [sortAndFilterCount]="vm?.sortAndFilterCount"
    [isSelected]="vm?.isSelected"
    [platformType]="platformService.platformType"
    [showClearAll]="platformService?.platformType === platformService?.platformEnum?.desktop"
    [buttonFullWidth]="platformService.platformType === platformService.platformEnum.mobile"
    [ngClass]="platformService?.platformType === platformService?.platformEnum?.tablet ? 'sort-clear-container-tablet' : 'sort-clear-container-default'"
    (openSortAndFilterListModalEmitter)="handleOpenSortAndFilterListModal(vm?.selectedListViewModel?.selectedListViewMode)"
    (clearSortAndFilterListModalEmitter)="handleClearSortAndFilterListModalEmitter(vm?.selectedListViewModel?.selectedListViewMode)"
  ></app-sort-and-filter-button>
</ng-template>

<!-- Add to list button -->
<ng-template #addToListButton>
  <ion-button
    data-cy="add-to-list-button"
    [class]="(vm?.isSelected) ? 'usf-fill-green-button':'usf-outline-green-button'"
    class="add-to-list-button"
    (click)="toggleAddToList()"
    [class.full-width]="platformService.platformType === platformService.platformEnum.mobile"
  >
    + {{ 'i18n.lists.addToList' | translate }}
  </ion-button>
</ng-template>

<!-- PME Toggle -->
<ng-template #pmeToggle let-listViewMode="listViewMode">
  <ion-segment
    data-cy="recently-purchased-pme-toggle"
    class="pme-toggle"
    mode="ios"
    value="{{ listViewMode }}"
    (ionChange)="handleListViewModeChange($event)"
  >
    <ion-segment-button
      data-cy="recently-purchased-ordering-toggle-button"
      value="{{ ListViewMode.ordering }}"
    >
      <ion-label data-cy="recently-purchased-ordering-toggle-text">
        {{ 'i18n.common.order' | translate }}
      </ion-label>
    </ion-segment-button>
    <ion-segment-button
      data-cy="recently-purchased-pricing-toggle-button"
      value="{{ ListViewMode.pricing }}"
    >
      <ion-label data-cy="recently-purchased-pricing-toggle-text">
        {{ 'i18n.productDetail.sellerDetail.pricing' | translate }}
      </ion-label>
    </ion-segment-button>
  </ion-segment>
</ng-template>

<!-- New Ellipsis -->
<ng-template #newEllipsis>
  <div data-cy="ellipsis-container">
    <ion-icon
      class="ellipsis-icon"
      data-cy="ellipsis-icon"
      name="ellipsis-vertical"
      (click)="openListOptions($event)"
    ></ion-icon>
  </div>
</ng-template>

<!-- SELECTED PRODUCTS FOOTER TEMPLATE -->
<ng-template #selectedProductsFooter>
  <ion-card
    *ngIf="vm?.numProductsSelected >= 1"
    id="product-selection-footer"
    data-cy="recent-purchase-selected-products-footer"
    class="selected-products-footer"
  >
    <ion-label
      *ngIf="platformService.platformType !== platformService.platformEnum.mobile"
      data-cy="recent-purchase-selected-products-text"
      class="list-number-of-products"
    >
      {{ (vm?.numProductsSelected ?? 0)}}&nbsp;{{ ((vm?.numProductsSelected ??
      0) > 1 ? 'i18n.lists.products' : 'i18n.lists.product') | translate
      }}&nbsp;{{ 'i18n.lists.selected' | translate }}
    </ion-label>
    <span
      data-cy="recent-purchase-separator-text"
      class="simple-space"
      *ngIf="platformService.platformType !== platformService.platformEnum.mobile"
      >|</span
    >
    <ion-label
      data-cy="recent-purchase-selected-products-text"
      class="list-select-all"
      *ngIf="vm.showSelectAll"
      (click)="selectAllProducts()"
    >
      {{ 'i18n.lists.selectAll' | translate }}
    </ion-label>
    <span
      data-cy="recent-purchase-separator-text"
      class="simple-space"
      *ngIf="platformService.platformType !== platformService.platformEnum.mobile && vm.showSelectAll"
      >|</span
    >
    <ion-label
      data-cy="recent-purchase-selected-products-text"
      class="list-deselect-all"
      (click)="deselectAllProducts()"
    >
      {{ 'i18n.lists.deselectAll' | translate }}
    </ion-label>
    <div class="spacer"></div>
    <ion-button
      class="usf-outline-green-button add-to-list-interact"
      (click)="openAddToList()"
    >
      {{ platformService.platformType !== platformService.platformEnum.mobile ?
      ('i18n.lists.chooseList' | translate) : (vm?.numProductsSelected + " " +
      ('i18n.lists.selected' | translate)) }}
      <ion-icon
        name="chevron-forward-outline"
        data-cy="add-to-inventory-selected-product-open-modal-button-icon"
      >
      </ion-icon>
    </ion-button>
  </ion-card>
</ng-template>

<!-- Download List Modal -->
<app-list-download-container
  [translateService]="translateService"
  (submitEvent)="downloadList($event)"
></app-list-download-container>

<!-- Print List Modal -->
<app-list-print-container
  [translateService]="translateService"
  (submitEvent)="downloadList($event)"
></app-list-print-container>

<!-- Download list modal-->
<ion-modal
  [isOpen]="listsOverlayService?.listDownloadModalOptions$?.value?.isOpen"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
  (ionModalDidDismiss)="closeDownloadListModal()"
  [ngClass]="platformService.platformType !== platformService.platformEnum.desktop ? 'ion-modal-touch' : (listsOverlayService?.listDownloadModalOptions$?.value?.isDownload ? 'modal-desktop-size-lg' : 'download-print-desktop')"
>
  <ng-template>
    <app-download-list-v2
      class="ion-page"
      [platformType]="platformService?.platformType"
      [listName]="listsOverlayService?.listDownloadModalOptions$?.value?.listName"
      [listId]="listsOverlayService?.listDownloadModalOptions$?.value?.listId"
      [isDownload]="listsOverlayService?.listDownloadModalOptions$?.value?.isDownload"
      [listTypeId]="listsOverlayService?.listDownloadModalOptions$?.value?.listTypeId"
      [hidePricingOption]="vm?.selectedCustomer?.ogPrintPriceInd === 'N'"
      (dismissEvent)="closeDownloadListModal()"
      (downloadEmitter)="downloadList($event)"
    >
    </app-download-list-v2>
  </ng-template>
</ion-modal>

<!-- Add to list modal-->
<ion-modal
  [isOpen]="this.addToListModalService.isModalOpen$ | async"
  (ionModalDidDismiss)="closeAndDeatachAddToListModal()"
  [class]="
  (platformService?.isTouchExperience$ | async)
    ? 'ion-modal-touch'
    : 'modal-desktop-size-xl'
"
  [initialBreakpoint]="
  platformService?.platformType !== platformService?.platformEnum.desktop
    ? 1
    : undefined
"
  [breakpoints]="
  platformService?.platformType !== platformService?.platformEnum.desktop
    ? [0, 1]
    : undefined
"
  id="addToListModal"
>
  <ng-template>
    <app-modal-with-nav-inline
      [rootPage]="this.addToListModalService.dualPaneRef"
      [rootPageParams]="this.addToListModalService.dualPaneModalData"
    >
    </app-modal-with-nav-inline>
  </ng-template>
</ion-modal>

<!-- Delete product warning modal -->
<ion-modal
  [isOpen]="(listsOverlayService?.recentlyPurchasedDeleteModalOptions$ | async).isOpen"
  (ionModalDidDismiss)="listsOverlayService?.closeRecentlyPurchasedDeleteModal()"
  [initialBreakpoint]="platformService?.platformType !== platformService?.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService?.platformType !== platformService?.platformEnum.desktop  ? [0, 1] : undefined"
  [ngClass]="platformService?.platformType !== platformService?.platformEnum.desktop ? 'ion-modal-touch' :'delete-item-non-usf-modal-desktop'"
>
  <ng-template>
    <app-delete-items-confirmation-modal
      class="ion-page"
      [platform]="platformService?.platformType"
      [isTouch]="platformService?.platformType !== platformService?.platformEnum.desktop"
      [totalSelected]="1"
      [additionalWarning]="'i18n.lists.recentlyPurchasedPage.thisWillBeRemoved'"
      [isWarning]="false"
      [singular]="'i18n.lists.thisProduct'"
      [plural]=""
      [hideCount]="true"
      (submitEvent)="deleteSingleProduct()"
      (dismissEvent)="listsOverlayService?.closeRecentlyPurchasedDeleteModal()"
    >
    </app-delete-items-confirmation-modal>
  </ng-template>
</ion-modal>

<ion-menu
  menuId="right-rail-menu-0"
  side="end"
  contentId="menu-context"
  [swipeGesture]="false"
  class="ion-modal-touch"
>
  <app-pme-right-rail
    class="ion-page"
    [isMobile]="true"
    [product]="vm?.selectedProduct"
    [hideLowLimit]="vm?.pmeLowLimitFeatureFlag"
    [showSGP]="vm?.pmeSGPFeatureFlag"
    (closeSidebar)="closeMobilePmeModal()"
    (productDetailsClick)="routeToPDPAndClosePmeModal(vm?.selectedProduct?.productNumber)"
    (priceChanged)="emitPriceChanged($event)"
    (closeManualApproval)="handleCloseManualApproval($event)"
  ></app-pme-right-rail>
</ion-menu>

<ion-menu
  side="start"
  menuId="recently-purchased-pme-menu"
  contentId="menu-context"
  [swipeGesture]="false"
>
  <app-pme-sort-filter
    class="ion-page"
    [sortFilterOptions]="vm?.pmeSortFilterOptions"
    [platformType]="platformService.platformType"
    [isRecentlyPurchased]="true"
    [sgpSort]="vm?.pmeSGPFeatureFlag"
    (saveEmitter)="savePmeSortAndFilter($event)"
    (closeEmitter)="closeSortFilterMenu()"
  ></app-pme-sort-filter>
</ion-menu>
